import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { modules_for, first_route } from '../apps/registry';
import { connect_google_calendar } from '../api';
import { IconArrowRight, IconCalendar } from './icons';

// The Office app code — the calendar connect only makes sense for a tenant that has the AI
// receptionist, so the card is gated on this grant.
const OFFICE_APP = 'captomi_office';

// Overview / app launcher — the signed-in landing. A card per app the tenant has, each opening
// that app's first view. The grid is driven entirely by the session's granted apps, so a tenant
// sees exactly the apps they're entitled to and nothing else.
export function Home() {
  const { state } = useAuth();
  if (state.status !== 'signed_in') return null;
  const { session } = state;
  const modules = modules_for(session.apps);
  const has_office = session.apps.includes(OFFICE_APP);
  const can_manage = session.role === 'owner' || session.role === 'admin';

  return (
    <div className="page">
      <div className="page-header">
        <h1>{session.first_name ? `Welcome back, ${session.first_name}` : 'Welcome back'}</h1>
        <p className="sub">
          You're signed in to <strong>{session.tenant_name}</strong> as {session.role}.
        </p>
      </div>

      {modules.length === 0 ? (
        <div className="card empty">
          <h2 style={{ marginBottom: 6 }}>No apps yet</h2>
          <p className="muted" style={{ margin: 0 }}>
            Your workspace doesn't have any Captomi apps enabled yet. Contact us to get set up.
          </p>
        </div>
      ) : (
        <>
          <div className="eyebrow" style={{ marginBottom: 12 }}>Your apps</div>
          <div className="grid" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))' }}>
            {modules.map((m) => (
              <Link key={m.app_code} to={first_route(m)} className="app-card">
                <div className="app-icon" style={{ background: m.accent ?? 'var(--accent)' }}>
                  {m.icon}
                </div>
                <div>
                  <div style={{ fontWeight: 650, fontSize: 15.5 }}>{m.label}</div>
                  {m.blurb && (
                    <div className="muted" style={{ fontSize: 13.5, marginTop: 4, lineHeight: 1.45 }}>
                      {m.blurb}
                    </div>
                  )}
                </div>
                <div
                  style={{
                    marginTop: 'auto',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    color: 'var(--accent)',
                    fontWeight: 600,
                    fontSize: 13.5,
                  }}
                >
                  Open <IconArrowRight style={{ width: 15, height: 15 }} />
                </div>
              </Link>
            ))}
          </div>
        </>
      )}

      {has_office && (
        <div className="card" style={{ maxWidth: 640, marginTop: 24 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
            <span style={{ color: 'var(--green-700, #1f5d3a)' }}>
              <IconCalendar />
            </span>
            <h2 style={{ margin: 0, fontSize: 17 }}>Google Calendar</h2>
          </div>
          <p className="muted" style={{ marginTop: 0 }}>
            Connect your Google Calendar so your receptionist only offers and books times that
            don't clash with what's already on it. We read your free/busy times only. We never
            change your calendar.
          </p>
          {can_manage ? (
            <button type="button" className="btn" onClick={() => connect_google_calendar()}>
              Connect Google Calendar
            </button>
          ) : (
            <p className="muted" style={{ margin: 0 }}>
              Ask an owner or admin on your team to connect Google Calendar.
            </p>
          )}
        </div>
      )}
    </div>
  );
}
